import React from "react";
import { Container, FormControl, Inline, Flex, Stack, List, ListItem, ListItemText, Typography } from "@airbus/components-react";


//CSS
import "../css/DonationInfo.css";
import { BrowserView, MobileView } from "react-device-detect";

class DonationInfoView extends React.Component {

    constructor(props){
        super();

        
        //states
        this.state={
            donation:props,
        }

    }

    /**
     * RENDERING
     * @returns dom
     */
     render() {

        return(
        
            <Container until='xl' style={{width:"100%", paddingRight:"0px !important"}}>
                {/**Browser display */}
                <BrowserView>
                <Inline spacing="3-x" align="left" >
                    {/*TRANSACTION ID*/}
                    <FormControl
                        label="ID Transaction"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.id}</div>
                    </FormControl>

                    {/*DATE*/}
                    <FormControl
                        label="Date"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.date}</div>
                    </FormControl>

                    {/*TYPE DON*/}
                    <FormControl
                        label="Type de don"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.type_don}</div>
                    </FormControl>

                    {/*MONTANT*/}
                    <FormControl
                        label="Montant"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.montant}</div>
                    </FormControl>

                    {/*DEVISE*/}
                    <FormControl
                        label="Devise"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.devise}</div>
                    </FormControl>

                    {/*MODE*/}
                    <FormControl
                        label="Mode"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.mode}</div>
                    </FormControl>

                    {/*STATUS*/}
                    <FormControl
                        label="Statut"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.status}</div>
                    </FormControl>


                    
                </Inline>

                <Inline spacing="3-x" align="left" >
                    {/*Donor comments*/}
                    <FormControl
                        label="Commentaires"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.donor_comment}</div>
                    </FormControl>
                    
                </Inline>

                <Inline spacing="3-x" align="left" >
                    {/*NOM*/}
                    <FormControl
                        label="Nom"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.nom}</div>
                    </FormControl>

                    {/*PRENOM*/}
                    <FormControl
                        label="Prénom"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.prenom}</div>
                    </FormControl>

                    {/*MAIL*/}
                    <FormControl
                        label="Mail"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.mail}</div>
                    </FormControl>
                </Inline>

                <Inline spacing="2-x" align="left" >
                    {/*ADRESSE 1*/}
                    <FormControl
                        label="Adresse 1"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.billing_address1}</div>
                    </FormControl>

                    {/*ADRESSE 2*/}
                    <FormControl
                        label="Adresse 2"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.billing_address2}</div>
                    </FormControl>


                </Inline>

                <Inline spacing="2-x" align="left" >
                    {/*ZIP*/}
                    <FormControl
                        label="Code Postal"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.billing_zip}</div>
                    </FormControl>
                    
                    {/*VILLE*/}
                    <FormControl
                        label="Ville"
                        style={{height:100}}
                    >
                        <div>{this.state.donation.donation.billing_city}</div>
                    </FormControl>
                </Inline>
                </BrowserView>

                {/**Mobile display */}
                <MobileView>
                    <Flex wrap justify='left' spacing='2-x'>
                        <List style={{height:"80%",  width:'100%'}}>
                        <div style={{width:'100%'}}>
                            <ListItem
                                key={this.state.donation.donation.id}
                                style={{lineHeight:2, width:'100%'}}
                            >
                                <Stack>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">ID Transaction:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.id}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Date:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.date}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Type de don:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.type_don}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Montant:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.montant}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Devise:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.devise}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Mode:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.mode}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Statut:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.status}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Commentaires:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.donor_comment}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Nom:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.nom}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Prénom:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.prenom}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Mail:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.mail}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Adresse 1:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.billing_address1}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Adresse 2:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.billing_address2}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Code postal:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.billing_zip}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                <ListItemText>
                                    <Inline spacing="2-x">
                                        <div><Typography variant="h7">Ville:</Typography></div>
                                        <div><Typography variant="h7">{this.state.donation.donation.billing_city}</Typography></div>
                                    </Inline>
                                </ListItemText>
                                </Stack>
                            </ListItem>
                        </div>
                        </List>
                    </Flex>
                </MobileView>
        </Container>
        )
    }


}

export default DonationInfoView;